import { useEffect, useRef } from 'react';
import type { AppDispatch } from '../../../redux/Store';
import {
  setActionList,
  setAxisActionList,
  setCustomActionList,
  setFrameworkActionLists,
  setInputBindingList,
  setStartCallConfig,
} from '../../../redux/EditorSlice';
import { FrameworkActionLists } from '../../../framework/frameworkClasses';

/**
 * When program code is empty, clear editor-derived state (action list, input mappings, etc.)
 * in a single effect that depends ONLY on `code` and `dispatch`.
 *
 * IMPORTANT: This effect must NOT depend on existingInputMappings (or any state that gets
 * updated by these dispatches). Otherwise: clear → dispatch → state change → effect re-runs
 * → infinite update loop. See commit 18a1aa4.
 */
export function useClearEditorStateWhenCodeEmpty(code: string, dispatch: AppDispatch, onClearLocalState?: () => void): void {
  const onClearRef = useRef(onClearLocalState);
  onClearRef.current = onClearLocalState;

  useEffect(() => {
    if (code.trim() !== '') return;
    dispatch(setActionList([]));
    dispatch(setAxisActionList([]));
    dispatch(setInputBindingList([]));
    dispatch(setCustomActionList([]));
    dispatch(setFrameworkActionLists(FrameworkActionLists ?? []));
    dispatch(setStartCallConfig(null));
    onClearRef.current?.();
  }, [code, dispatch]);
}
